(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // The cart drawer owns every write to the cart for the whole theme and
  // exposes them as window.NocountCart, so the product form and the cart page
  // do not each need their own copy of this.
  //
  // Liquid is not rendered inside this tag, so URLs and messages are read off
  // data attributes. Listeners are delegated from the document because the
  // panel is replaced wholesale on every change.
  (function () {
    const DRAWER = '[data-cart-drawer]';
    const DEBOUNCE = 300;

    const getDrawer = () => document.querySelector(DRAWER);
    const getPanel = () => document.querySelector('[data-cart-drawer-panel]');

    if (!getDrawer()) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // /cart/change.js is order-sensitive: two in-flight writes can land the
    // wrong way round. One promise chain keeps them strictly sequential.
    let queue = Promise.resolve();
    const enqueue = (task) => {
      queue = queue.then(task).catch(() => {});
      return queue;
    };

    // One pending timer per line, so holding down "+" sends a single request.
    const timers = new Map();

    /* ---------- Open and close ---------- */

    // showModal() blocks interaction but not scrolling, so the page behind
    // would still move under the drawer on a phone.
    const lockScroll = () => {
      const gutter = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (gutter > 0) document.body.style.paddingInlineEnd = gutter + 'px';
    };

    const unlockScroll = () => {
      document.body.style.overflow = '';
      document.body.style.paddingInlineEnd = '';
    };

    const open = () => {
      const drawer = getDrawer();
      if (!drawer || drawer.open || typeof drawer.showModal !== 'function') return;
      drawer.showModal();
      lockScroll();
      // The class has to land in a later frame than showModal(), or the panel
      // is painted in its open position and there is nothing to transition.
      window.requestAnimationFrame(() => drawer.classList.add('is-open'));
    };

    const close = () => {
      const drawer = getDrawer();
      if (!drawer || !drawer.open) return;
      drawer.classList.remove('is-open');

      const panel = getPanel();
      if (reduceMotion || !panel) {
        drawer.close();
        return;
      }

      // Wait for the slide out, but never hang if the transition never fires.
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        panel.removeEventListener('transitionend', onEnd);
        drawer.close();
      };
      const onEnd = (event) => {
        if (event.target === panel && event.propertyName === 'transform') finish();
      };
      panel.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, 500);
    };

    // Esc closes a <dialog> instantly, which would skip the slide.
    getDrawer().addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    // Covers every route out, including a close we did not initiate.
    getDrawer().addEventListener('close', () => {
      getDrawer().classList.remove('is-open');
      unlockScroll();
    });

    /* ---------- Feedback ---------- */

    const setBusy = (busy) => {
      getDrawer()?.setAttribute('aria-busy', busy ? 'true' : 'false');
    };

    const showError = (message) => {
      const region = getDrawer()?.querySelector('[data-cart-error]');
      if (!region) return;
      region.textContent = message || '';
      region.hidden = !message;
    };

    const announce = (message) => {
      const region = document.querySelector('[data-cart-drawer-status]');
      if (!region || !message) return;
      // Re-setting identical text is not re-announced, so clear it first.
      region.textContent = '';
      window.setTimeout(() => {
        region.textContent = message;
      }, 60);
    };

    const setCount = (count) => {
      if (typeof count !== 'number' || Number.isNaN(count)) return;
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === 0;
      });
    };

    /* ---------- Rendering ---------- */

    // Remember where the keyboard was before the panel is swapped out.
    const readFocus = () => {
      const active = document.activeElement;
      const line = active && active.closest ? active.closest('[data-cart-line-key]') : null;
      if (!line || !line.closest(DRAWER)) return null;
      return {
        key: line.dataset.cartLineKey,
        step: active.dataset.quantityStep,
        isInput: active.matches('[data-quantity-input]'),
      };
    };

    const restoreFocus = (mark) => {
      const drawer = getDrawer();
      if (!mark || !drawer) return;
      const line = drawer.querySelector('[data-cart-line-key="' + CSS.escape(mark.key) + '"]');
      if (!line) {
        // The line is gone — park focus somewhere inside the dialog.
        drawer.querySelector('[data-cart-drawer-close]')?.focus();
        return;
      }
      const target = mark.isInput
        ? line.querySelector('[data-quantity-input]')
        : line.querySelector('[data-quantity-step="' + mark.step + '"]');
      if (target) target.focus();
    };

    // Swaps in the panel that came back from the Section Rendering API and
    // syncs the header badge from it. Unknown section ids are ignored, so the
    // cart page can hand over its whole `sections` object untouched.
    const applySections = (sections) => {
      const drawer = getDrawer();
      if (!drawer || !sections) return;

      const html = sections[drawer.dataset.cartDrawerSection];
      if (!html) return;

      const next = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-cart-drawer-panel]');
      const current = getPanel();
      if (!next || !current) return;

      const mark = readFocus();
      current.replaceWith(next);
      restoreFocus(mark);

      setCount(Number(next.dataset.cartCountValue));
    };

    /* ---------- Writes ---------- */

    const sectionParams = () => {
      const drawer = getDrawer();
      return {
        sections: drawer.dataset.cartDrawerSection,
        sections_url: window.location.pathname,
      };
    };

    // A 422 carries a description Shopify has already localised, so it is worth
    // showing. Anything else is a transport failure and is not.
    const readResponse = (response, fallback) =>
      response.json().then((data) => {
        if (!response.ok) {
          const refusal = new Error(data.description || data.message || fallback);
          refusal.fromCart = true;
          throw refusal;
        }
        return data;
      });

    const add = (form) => {
      const drawer = getDrawer();
      if (!drawer) return Promise.reject(new Error('No cart drawer'));

      const fallback = drawer.dataset.cartErrorMessage;
      const params = sectionParams();
      const body = new FormData(form);
      body.append('sections', params.sections);
      body.append('sections_url', params.sections_url);

      // No Content-Type header — the browser has to set the multipart boundary.
      return fetch(drawer.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body,
      })
        .then((response) => readResponse(response, fallback))
        .then((data) => {
          applySections(data.sections);
          showError('');
          open();
          announce(drawer.dataset.cartAddedMessage);
          return data;
        });
    };

    const change = (body) => {
      const drawer = getDrawer();
      if (!drawer) return Promise.resolve();

      const fallback = drawer.dataset.cartErrorMessage;
      const updated = drawer.dataset.cartUpdatedMessage;

      setBusy(true);
      showError('');

      return fetch(drawer.dataset.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({}, body, sectionParams())),
      })
        .then((response) => readResponse(response, fallback))
        .then((data) => {
          applySections(data.sections);
          setCount(data.item_count);
          announce(updated);
        })
        .catch((error) => {
          showError(error.fromCart ? error.message : fallback);
        })
        .then(() => setBusy(false));
    };

    /* ---------- Wiring ---------- */

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-close]')) {
        close();
        return;
      }

      // The header cart link. On the cart page itself there is nothing to gain
      // from a drawer, so the link is left to navigate.
      const opener = event.target.closest('[data-cart-drawer-open]');
      if (opener && !document.querySelector('[data-cart]')) {
        event.preventDefault();
        open();
        return;
      }

      // A click that lands on the dialog itself is a click beside the panel.
      if (event.target.matches('dialog.cart-drawer')) {
        close();
        return;
      }

      const remove = event.target.closest('[data-cart-remove]');
      if (remove && remove.closest(DRAWER)) {
        // Falls through to the plain href when this script never runs.
        event.preventDefault();
        const line = remove.closest('[data-cart-line-key]');
        if (!line) return;
        window.clearTimeout(timers.get(line.dataset.cartLineKey));
        enqueue(() => change({ id: line.dataset.cartLineKey, quantity: 0 }));
      }
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches('[data-quantity-input]')) return;

      const line = input.closest('[data-cart-line-key]');
      if (!line || !line.closest(DRAWER)) return;

      // A cleared or unparseable field snaps back to the quantity the server
      // last rendered — only a deliberate 0 removes the line.
      const raw = input.value.trim();
      const quantity = parseInt(raw, 10);
      if (raw === '' || Number.isNaN(quantity) || quantity < 0) {
        input.value = input.defaultValue;
        return;
      }

      const key = line.dataset.cartLineKey;
      input.value = quantity;

      window.clearTimeout(timers.get(key));
      timers.set(
        key,
        window.setTimeout(() => {
          timers.delete(key);
          enqueue(() => change({ id: key, quantity: quantity }));
        }, DEBOUNCE)
      );
    });

    // Enter inside the drawer's quantity field would submit nothing useful.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (!event.target.matches('[data-quantity-input]')) return;
      if (!event.target.closest(DRAWER)) return;

      event.preventDefault();
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    });

    window.NocountCart = {
      add: add,
      open: open,
      close: close,
      applySections: applySections,
      setCount: setCount,
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Cart quantities apply as soon as they change. Every write goes to the Cart
  // AJAX API and asks for this section back, so the markup that comes back is
  // rendered by Liquid in the shopper's own locale and currency — nothing here
  // formats money or translates strings.
  //
  // Liquid is not rendered inside this tag, so every URL and message is read off
  // data attributes on the section root. Listeners are delegated from the
  // document because the section root itself is replaced when the cart empties.
  (function () {
    const CART = '[data-cart]';
    const DEBOUNCE = 300;

    const getCart = () => document.querySelector(CART);

    // /cart/change.js is order-sensitive: two in-flight writes can land the
    // wrong way round. One promise chain keeps them strictly sequential.
    let queue = Promise.resolve();
    const enqueue = (task) => {
      queue = queue.then(task).catch(() => {});
      return queue;
    };

    // One pending timer per line, so holding down "+" sends a single request.
    const timers = new Map();

    const setBusy = (busy) => {
      getCart()?.setAttribute('aria-busy', busy ? 'true' : 'false');
    };

    const showError = (message) => {
      const region = getCart()?.querySelector('[data-cart-error]');
      if (!region) return;
      region.textContent = message || '';
      region.hidden = !message;
    };

    const announce = () => {
      const region = document.querySelector('[data-cart-status]');
      if (!region) return;
      // Re-setting identical text is not re-announced, so clear it first.
      const message = region.dataset.cartStatusMessage;
      region.textContent = '';
      window.setTimeout(() => {
        region.textContent = message;
      }, 60);
    };

    const setCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === 0;
      });
    };

    // Remember where the keyboard was before the line items are swapped out.
    const readFocus = () => {
      const active = document.activeElement;
      const line = active && active.closest ? active.closest('[data-cart-line-key]') : null;
      if (!line) return null;
      return {
        key: line.dataset.cartLineKey,
        step: active.dataset.quantityStep,
        isInput: active.matches('[data-quantity-input]'),
      };
    };

    const restoreFocus = (mark) => {
      if (!mark) return;
      const line = document.querySelector('[data-cart-line-key="' + CSS.escape(mark.key) + '"]');
      if (!line) {
        // The line is gone — park focus on the list rather than on <body>.
        const items = document.querySelector('[data-cart-items]');
        if (items) {
          items.setAttribute('tabindex', '-1');
          items.focus();
        }
        return;
      }
      const target = mark.isInput
        ? line.querySelector('[data-quantity-input]')
        : line.querySelector('[data-quantity-step="' + mark.step + '"]');
      if (target) target.focus();
    };

    const render = (html) => {
      const current = getCart();
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(CART);
      if (!current || !source) return;

      const hadItems = current.querySelector('[data-cart-items]');
      const hasItems = source.querySelector('[data-cart-items]');

      // Last line removed (or first line added): the whole shape changes.
      if (!hadItems || !hasItems) {
        current.replaceWith(source);
        return;
      }

      const mark = readFocus();

      // Everything outside these three stays put — notably the order note,
      // which the shopper may be typing into.
      ['[data-cart-count-label]', '[data-cart-items]', '[data-cart-summary]'].forEach((selector) => {
        const next = source.querySelector(selector);
        const previous = current.querySelector(selector);
        if (next && previous) previous.replaceWith(next);
      });

      restoreFocus(mark);
    };

    const change = (body) => {
      const cart = getCart();
      if (!cart) return Promise.resolve();

      const sectionId = cart.dataset.cartSectionId;
      const fallback = cart.dataset.cartErrorMessage;

      // The drawer lives in the layout, so it is on this page too. Asking for
      // it in the same round trip keeps it from going stale behind the scenes.
      const drawer = document.querySelector('[data-cart-drawer]');
      const requested = drawer
        ? sectionId + ',' + drawer.dataset.cartDrawerSection
        : sectionId;

      setBusy(true);
      showError('');

      return fetch(cart.dataset.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(
          Object.assign({}, body, { sections: requested, sections_url: window.location.pathname })
        ),
      })
        .then((response) =>
          response.json().then((data) => {
            // 422 means the cart refused the change, e.g. not enough stock. Its
            // description is already localised by Shopify, so it is worth
            // showing; anything else is a transport failure and is not.
            if (!response.ok) {
              const refusal = new Error(data.description || data.message || fallback);
              refusal.fromCart = true;
              throw refusal;
            }
            return data;
          })
        )
        .then((data) => {
          setCount(data.item_count);
          render((data.sections && data.sections[sectionId]) || '');
          window.NocountCart?.applySections(data.sections);
          announce();
        })
        .catch((error) => {
          showError(error.fromCart ? error.message : fallback);
        })
        .then(() => setBusy(false));
    };

    const saveNote = (note) => {
      const cart = getCart();
      if (!cart) return;
      const fallback = cart.dataset.cartErrorMessage;

      enqueue(() =>
        fetch(cart.dataset.cartUpdateUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note }),
        }).catch(() => showError(fallback))
      );
    };

    document.addEventListener('change', (event) => {
      const target = event.target;

      if (target.matches('[data-cart-note]')) {
        saveNote(target.value);
        return;
      }

      if (!target.matches('[data-quantity-input]')) return;

      const line = target.closest('[data-cart-line-key]');
      if (!line || !line.closest(CART)) return;

      // A cleared or unparseable field snaps back to the quantity the server
      // last rendered — only a deliberate 0 removes the line.
      const raw = target.value.trim();
      const quantity = parseInt(raw, 10);
      if (raw === '' || Number.isNaN(quantity) || quantity < 0) {
        target.value = target.defaultValue;
        return;
      }

      const key = line.dataset.cartLineKey;
      target.value = quantity;

      window.clearTimeout(timers.get(key));
      timers.set(
        key,
        window.setTimeout(() => {
          timers.delete(key);
          enqueue(() => change({ id: key, quantity: quantity }));
        }, DEBOUNCE)
      );
    });

    document.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove || !remove.closest(CART)) return;

      const line = remove.closest('[data-cart-line-key]');
      if (!line) return;

      // Falls through to the plain href when this script never runs.
      event.preventDefault();
      window.clearTimeout(timers.get(line.dataset.cartLineKey));
      enqueue(() => change({ id: line.dataset.cartLineKey, quantity: 0 }));
    });

    // Without the Update button, Enter in a quantity field would submit the
    // form — which is the Checkout button. Apply the quantity instead.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (!event.target.matches('[data-quantity-input]')) return;
      if (!event.target.closest(CART)) return;

      event.preventDefault();
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Adds a hairline under the header once the page leaves the top.
  // Purely positional feedback — no animation beyond a colour transition.
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    let ticking = false;

    const update = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();

    // Close the mobile menu when a link inside it is followed or Escape is pressed.
    const disclosure = header.querySelector('[data-header-disclosure]');
    if (!disclosure) return;

    disclosure.addEventListener('click', (event) => {
      if (event.target.closest('a')) disclosure.removeAttribute('open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') disclosure.removeAttribute('open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Gallery: thumbnails drive the scroll-snap track ---------- */
    const track = root.querySelector('[data-gallery-track]');
    const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));

    // Each slide is exactly one track-width wide, so the offset is arithmetic.
    // offsetLeft would be measured from the nearest positioned ancestor, not the track.
    const showSlide = (index) => {
      if (!track || index < 0 || index >= slides.length) return;
      track.scrollTo({
        left: index * track.clientWidth,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    };

    const markActiveThumb = (index) => {
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.index);
        showSlide(index);
        markActiveThumb(index);
      });
    });

    // Keep the thumbnails honest when the track is swiped directly.
    if (track && slides.length > 1 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) markActiveThumb(slides.indexOf(entry.target));
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
    }

    /* ---------- Variant picker ---------- */
    const dataEl = root.querySelector('[data-variant-json]');
    const idInput = root.querySelector('[data-variant-id]');
    if (!dataEl || !idInput) return;

    // The hidden input ships disabled so the <noscript> select owns the form
    // when this script never runs. We're running, so take ownership back.
    idInput.disabled = false;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    const fieldsets = Array.from(root.querySelectorAll('[data-product-option]'));
    if (!fieldsets.length) return;

    const priceCurrent = root.querySelector('[data-price-current]');
    const priceCompare = root.querySelector('[data-price-compare]');
    const submit = root.querySelector('[data-add-to-cart]');
    const submitText = root.querySelector('[data-add-to-cart-text]');

    const selection = () =>
      fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });

    const findVariant = (values) =>
      variants.find((variant) => values.every((value, i) => variant.options[i] === value));

    // Strike through values that can't be reached from the current selection.
    const markUnavailable = (values) => {
      fieldsets.forEach((fieldset, index) => {
        fieldset.querySelectorAll('input').forEach((input) => {
          const candidate = values.slice();
          candidate[index] = input.value;
          const match = variants.find(
            (variant) =>
              variant.available && candidate.every((value, i) => variant.options[i] === value)
          );
          const label = fieldset.querySelector('label[for="' + input.id + '"]');
          if (label) label.toggleAttribute('data-unavailable', !match);
        });
      });
    };

    const update = () => {
      const values = selection();
      const variant = findVariant(values);

      fieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        const readout = fieldset.querySelector('[data-option-selected]');
        if (checked && readout) readout.textContent = checked.value;
      });

      markUnavailable(values);

      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = submitText.dataset.unavailable;
        return;
      }

      idInput.value = variant.id;

      if (priceCurrent) {
        priceCurrent.textContent = variant.price;
        priceCurrent.classList.toggle('product__price-current--sale', Boolean(variant.compare_at_price));
      }

      if (priceCompare) {
        priceCompare.textContent = variant.compare_at_price || '';
        priceCompare.toggleAttribute('hidden', !variant.compare_at_price);
      }

      if (submit) submit.disabled = !variant.available;
      if (submitText) {
        submitText.textContent = variant.available
          ? submitText.dataset.addToCart
          : submitText.dataset.soldOut;
      }

      if (variant.media_position !== null) showSlide(variant.media_position - 1);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    fieldsets.forEach((fieldset) => fieldset.addEventListener('change', update));
    markUnavailable(selection());
  })();

  // Add to cart without leaving the page. Its own IIFE: the variant picker
  // above bails early on products with a single variant, and this has to run
  // for those too.
  //
  // sections/cart-drawer.liquid owns the request and the drawer; this only
  // hands over the form and reports a refusal next to the button. With no
  // JavaScript — or no drawer on the page — the form posts to /cart as before.
  (function () {
    const form = document.querySelector('.product-form');
    if (!form) return;

    const submit = form.querySelector('[data-add-to-cart]');
    const error = form.querySelector('[data-product-error]');

    const showError = (message) => {
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    };

    form.addEventListener('submit', (event) => {
      if (!window.NocountCart) return;

      event.preventDefault();
      showError('');
      if (submit) submit.disabled = true;

      window.NocountCart.add(form)
        .catch((reason) => {
          showError(reason.fromCart ? reason.message : error?.dataset.errorMessage);
        })
        .then(() => {
          if (submit) submit.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
